import { Population } from './enum/population.enum';
import { LookupState } from './model/lookup-state.model';
import { MainState } from './model/main-state.model';
import { SelectedItemInternal } from './model/selected-item-internal.model';

const stateWrapper: {
    lookup: LookupState | null;
    main: Map<string, MainState | null>;
} = {
    lookup: {},
    main: new Map<string, MainState | null>(),
};

export const currentLookupState = (): LookupState => {
    return stateWrapper.lookup;
};

export const createMainState = (that: any): MainState => {
    const key = Math.random().toString(36).substr(2);
    stateWrapper.main.set(key, {
        selectedPopulation: Population.User,
        selected: new Set<SelectedItemInternal>(),
        selectedAsArray: [],
    });
    that._stateKey = key;
    return stateWrapper.main.get(that._stateKey);
};

export const currentMainState = (that: any): MainState => {
    return stateWrapper.main.get(that._stateKey);
};

export const deleteMainState = (that: any): void => {
    stateWrapper.main.delete(that._stateKey);
};
